'use client';
import { useEffect, useRef, useState } from 'react';
import Image from 'next/image';
import gsap from 'gsap';
import styles from './CartTicket.module.css';
import Link from 'next/link';

export default function CartTicket() {
  const ticketRef = useRef(null);

  const [cartItems, setCartItems] = useState([
    {
      id: 1,
      name: 'ZINC Premium',
      image: 'https://longevity20155.sirv.com/zinc/1.webp',
      price: 30.00,
      quantity: 1,
    },
    {
      id: 2,
      name: 'MINCI Advanced',
      image: 'https://longevity20155.sirv.com/minci/1.webp',
      price: 35.00,
      quantity: 2,
    },
  ]);

  const updateQuantity = (id, delta) => {
    setCartItems(items =>
      items.map(item =>
        item.id === id
          ? { ...item, quantity: Math.max(1, item.quantity + delta) }
          : item
      )
    );
  };

  const removeItem = (id) => {
    setCartItems(items => items.filter(item => item.id !== id));
  };



  const currentDate = new Date().toLocaleDateString('en-US', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  });

  const subtotal = cartItems.reduce((sum, item) => sum + (item.price * item.quantity), 0);
  const shipping = 5.00;
  const total = subtotal + shipping;
  const totalItems = cartItems.reduce((sum, item) => sum + item.quantity, 0);

  return (


    <div ref={ticketRef} className={styles.ticketContainer} id='ticketnavbar'>

      <div className={styles.ticket} >
        {/* Perforation edge */}
        <div className={styles.perforation}></div>

        {/* Ticket content */}
        <div className={styles.ticketContent}>
          <div className={styles.header}>
            <h3 className={styles.storeName}>Logvplus</h3>
            <p className={styles.date}>{currentDate}</p>
          </div>

          <div className={styles.divider}>** SHOPPING CART **</div>

          <div className={styles.orderInfo}>
            <p className={styles.itemCount}>{totalItems} ITEM{totalItems !== 1 ? 'S' : ''}</p>
          </div>

          {/* Cart Items */}
          <div className={styles.itemsSection}>
            {cartItems.map((item) => (
              <div key={item.id} className={styles.cartItem}>
                <div className={styles.itemHeader}>
                  <div className={styles.itemImageSmall}>
                    <Image
                      src={item.image}
                      alt={item.name}
                      width={40}
                      height={40}
                      unoptimized
                    />
                  </div>
                  <div className={styles.itemInfo}>
                    <p className={styles.itemName}>{item.name}</p>
                    <p className={styles.itemPrice}> DT{item.price.toFixed(2)} EA</p>
                  </div>
                  <button
                    className={styles.removeBtn}
                    onClick={() => removeItem(item.id)}
                    title="Remove"
                  >
                    ×
                  </button>
                </div>

                <div className={styles.itemActions}>
                  <div className={styles.quantity}>
                    <button onClick={() => updateQuantity(item.id, -1)}>−</button>
                    <span>QTY: {item.quantity}</span>
                    <button onClick={() => updateQuantity(item.id, 1)}>+</button>
                  </div>
                  <div className={styles.itemTotal}>
                    {(item.price * item.quantity).toFixed(2)} DT
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className={styles.divider}>-------------------------</div>

          <div className={styles.priceSection}>
            <div className={styles.priceRow}>
              <span>SUBTOTAL:</span>
              <span> DT{subtotal.toFixed(2)}</span>
            </div>
            <div className={styles.priceRow}>
              <span>SHIPPING:</span>
              <span> DT{shipping.toFixed(2)}</span>
            </div>
            <div className={`${styles.priceRow} ${styles.total}`}>
              <span>TOTAL:</span>
              <span> DT{total.toFixed(2)}</span>
            </div>
          </div>

          <div className={styles.divider}>*************************</div>

          <div className={styles.footer}>
           <Link href={"/cart"}>   <button className={styles.checkoutBtn}>
              PROCEED TO CHECKOUT
            </button></Link>

            <div className={styles.barcode}>
              <div className={styles.barcodeLines}>
                {[...Array(30)].map((_, i) => (
                  <div key={i} className={styles.barcodeLine}></div>
                ))}
              </div>
              <p className={styles.barcodeNumber}>*CART-{totalItems}*</p>
            </div>
          </div>
        </div>

      <button className={styles.closeBtn} onClick={e => { gsap.timeline().to("." + styles.ticketContainer, { transform: "translateY(150%)", duration: 1 }) }}>×</button>
      </div>
    </div>

  );
}
